var VIEW_MODE = {
  SITE: 'SITE',
  EDIT: 'EDIT',
  PREVIEW: 'PREVIEW',
  PRERENDER: 'PRERENDER',
  SEO: 'SEO'
};
export default VIEW_MODE;